import React from "react";
import { NavLink } from "react-router-dom";

function PolicySideLinks({ children }) {
    const linkStyle = {
        display: "block",
        padding: "8px 0",
        textDecoration: "none",
        color: "#333",
    };

    const activeStyle = {
        fontWeight: "bold",
        color: "#ef4444", // active color
    };

    return (
        <div style={{ display: "flex", minHeight: "100vh", background: "white" }}>
            {/* Sidebar */}
            <aside
                style={{
                    width: "250px",
                    borderRight: "1px solid #ddd",
                    padding: "25px",
                }}
            >
                <h3 className="font-bold">Quick Links</h3>
                <ul style={{ listStyle: "none", padding: 0, lineHeight: "2rem", marginTop: 4 }}>
                    <li>
                        <NavLink
                            to="/aboutUs" target="-blank"
                            style={({ isActive }) => (isActive ? { ...linkStyle, ...activeStyle } : linkStyle)}
                        >
                            AboutUs
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to="/contactUs" target="-blank"
                            style={({ isActive }) => (isActive ? { ...linkStyle, ...activeStyle } : linkStyle)}
                        >
                            ContactUs
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to="/terms-condition" target="-blank"
                            style={({ isActive }) => (isActive ? { ...linkStyle, ...activeStyle } : linkStyle)}
                        >
                            Terms & Conditions
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to="/privacy-policy" target="-blank"
                            style={({ isActive }) => (isActive ? { ...linkStyle, ...activeStyle } : linkStyle)}
                        >
                            Privacy Policy
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to="/shipping-policy" target="-blank"
                            style={({ isActive }) => (isActive ? { ...linkStyle, ...activeStyle } : linkStyle)}
                        >
                            Shipping Policy
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to="/return-policy" target="-blank"
                            style={({ isActive }) => (isActive ? { ...linkStyle, ...activeStyle } : linkStyle)}
                        >
                            Return Policy
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to="/faqs" target="-blank"
                            style={({ isActive }) => (isActive ? { ...linkStyle, ...activeStyle } : linkStyle)}
                        >
                            Faqs
                        </NavLink>
                    </li>

                </ul>
            </aside>

            {/* Content Area */}
            <main style={{ flex: 1, padding: "20px" }}>{children}</main>
        </div>
    );
}

export default PolicySideLinks;
